import { render, staticRenderFns } from "./SelectorShelves.vue?vue&type=template&id=7afb6b1f&scoped=true&"
import script from "./SelectorShelves.vue?vue&type=script&lang=js&"
export * from "./SelectorShelves.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7afb6b1f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37614586/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7afb6b1f')) {
      api.createRecord('7afb6b1f', component.options)
    } else {
      api.reload('7afb6b1f', component.options)
    }
    module.hot.accept("./SelectorShelves.vue?vue&type=template&id=7afb6b1f&scoped=true&", function () {
      api.rerender('7afb6b1f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/fmfmo/accessories/SelectorShelves.vue"
export default component.exports